import React, { useEffect, useState, useRef } from "react";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { Button } from "../../../../shadcn/components/ui/button";
import { intiateEmailLoginWithOtp, intiateMobileLoginWithOtp } from "services";
import { useDispatch } from "react-redux";
import { setGuestUser } from "store";

const emailRegEx: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
interface BidderLoginFormProps {
  setInputModalOpen: any;
  inputModalOpen: any;
  form?: any;
}
export default function BidderLoginForm({
  setInputModalOpen,
  inputModalOpen,
  form,
}: BidderLoginFormProps) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    return () => {
      isSubmittingRef.current = false;
    };
  }, []);

  // const form = useBetaForm({
  //   user_identity: "",
  // });
  // const form_constraints = {
  //   user_identity: {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^Please enter a valid email or mobile number.",
  //     },
  //   },
  // };

  // useEffect(() => {
  //   form.setValidationRules(form_constraints);
  // }, []);

  // useEffect(() => {
  //   if (inputModalOpen === true && form.getField("user_identity")) return;
  //   form.setField("user_identity", "");
  //   form.removeError("user_identity");
  // }, [inputModalOpen]);

  const handleSubmit = async () => {
    if (isSubmittingRef.current) return;

    isSubmittingRef.current = true;
    setIsLoading(true);

    try {
      form.value.user_identity = form.value.user_identity.trim().toLowerCase();
      if (form.validate()) {
        let isEmail = emailRegEx.test(form.value.user_identity);
        let isMobile = mobileNumberRegEx.test(form.value.user_identity);
        if (isEmail) {
          await intiateEmailLoginWithOtp(form).then((res: any) => {
            if (res.message === "AttributeNotVerified") {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: true } }),
              );
              setInputModalOpen(false);
            } else {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: true } }),
              );
              setInputModalOpen(false);
            }
          });
        } else if (isMobile) {
          await intiateMobileLoginWithOtp(form).then((res: any) => {
            if (res.message === "AttributeNotVerified") {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: false } }),
              );
              setInputModalOpen(false);
            } else {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: false } }),
              );
              setInputModalOpen(false);
            }
          });
        } else {
          form.setErrors({
            user_identity: ["Please enter a valid email or mobile number."],
          });
        }
      }
    } catch (error: any) {
      console.log("check here error", error);
      setIsLoading(false);
      isSubmittingRef.current = false;
    }
  };
  return (
    <div className="font-sans">
      <div className="text-2xl text-brand-textBlack lg:text-4xl">
        Get Started Now
      </div>
      <div className="text-xs lg:text-sm mt-1">
        Enter your details to access your account
      </div>
      <form
        className="flex flex-col space-y-8 w-full mt-6 lg:mt-8"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <div className="space-y-2">
          <input
            type="text"
            placeholder="Enter email or Mobile number"
            value={form.getField("user_identity")}
            onChange={
              (e) => {
                const input = e.target;
                const start = input.selectionStart;
                const end = input.selectionEnd;

                const lower = input.value.toLowerCase();
                form.setField("user_identity", lower);
                requestAnimationFrame(() => {
                  input.setSelectionRange(start, end);
                });
              }
              // form.setField("user_identity", e.target.value?.toLowerCase())
            }
            className="bg-white border-none focus:ring-brand-orange h-10 lg:h-12 p-2 lg:p-3   w-full font-openSans font-semibold text-web-body-sm leading-4 text-[#A1A0A0]"
          />
          {form.errors.get("user_identity") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("user_identity")[0]}
            </p>
          ) : null}
        </div>
      </form>

      <Button
        id="submit-otp-btn"
        className="mt-10 lg:mt-12 w-full"
        disabled={isLoading}
        onClick={() => handleSubmit()}
      >
        {isLoading ? "Sending OTP..." : "Get started"}
      </Button>
      <div className="border-t-[1px] border-[#D1D1D1] my-6 lg:my-9" />
      <p className="font-sans text-xs lg:text-sm text-login-color text-center mb-4">
        By logging in, I agree to the{" "}
        <a
          href={
            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/termsandconditions`
              : "/termsandconditions"
          }
          className="underline font-sans"
        >
          Privacy policy & terms and conditions
        </a>
      </p>
    </div>
  );
}
